import * as React from 'react';
import { LinkTag, TagsContainer } from 'naan/primitives/tags';
import { Link as RouterLink } from 'react-router-dom';
import { makeFilterLink } from 'common/filtering/make-filter-link';
import { MappedTag } from 'core/models/catalog/unit-catalog-data';

type VolumeTagLinksProps = {
  tags: MappedTag[];
};

const mapTagTypeToFilterType = {
  topic: 'topics',
  country: 'countries',
} as const;

export const VolumeTagLinks = ({ tags }: VolumeTagLinksProps) => {
  return (
    <TagsContainer>
      {tags.map((tag, index) => (
        <LinkTag
          as={RouterLink}
          key={index}
          type={tag.type}
          to={makeFilterLink('/discover', mapTagTypeToFilterType[tag.type], [
            tag.label,
          ])}
        >
          {tag.label}
        </LinkTag>
      ))}
    </TagsContainer>
  );
};
